import { WRONG_PLATFORM_NATIVE_CRASH_MESSAGE } from '../constants';

export const nativeCrash = (): void => {
  console.log(WRONG_PLATFORM_NATIVE_CRASH_MESSAGE);
};
